<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i>企业动态
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="next-box">
                <el-button
                    type="danger"
                    icon="el-icon-delete-solid"
                    @click="delAllSelection"
                    v-if="$store.state.roleid!=5"
                >批量删除</el-button>
                 <el-button
                    type="primary"
                    icon="el-icon-circle-plus"
                    @click="addVisiable = true"
                >添加</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="title" label="动态标题"  align="center"></el-table-column>
                <el-table-column prop="img" label="企业动态封面" width="100"  align="center">
                        <template slot-scope="scope">
                        <el-image
                            class="table-td-thumb"
                            :src="scope.row.img"
                            :preview-src-list="[scope.row.img]"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="企业动态"  align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="handleEdit(scope.$index, scope.row)"
                        >查看详情（编辑）</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300" align="center" prop="disable">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                            v-if="$store.state.roleid!=5"
                        >删除</el-button>
                       
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 添加弹出框 -->
        <el-dialog title="添加企业动态" :visible.sync="addVisiable" width="1000px">
              <el-form ref="addForm" :rules="rules" :model="addForm" label-width="100px" >
                    <el-form-item label="企业动态标题" prop="title">
                        <el-input v-model="addForm.title"  />
                    </el-form-item>
                    <el-form-item label="封面图片" prop="info_pic"  >
                    <el-upload
                        :limit="1"
                        action="http://localhost:9999/cat/adopt/insertAdopt"
                        ref="uploadimg"
                        list-type="picture-card"
                        :auto-upload="false"
                        :data="addForm"
                        :file-list="addForm.info_pic"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :http-request="uploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                 <el-form-item label="企业动态" prop="content">
                   <mavon-editor v-model="addForm.content" ref="md" @imgAdd="$imgAdd" @change="change" style="min-height: 600px"/>
                </el-form-item>
                
            </el-form>
            <el-button class="editor-btn" type="primary" @click="addData()">提交</el-button>
        </el-dialog>
         <!-- 编辑弹出框 -->
        <el-dialog title="编辑企业动态" :visible.sync="editVisible" width="1000px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="100px" >
                <el-form-item label="企业动态标题" prop="title">
                    <el-input v-model="editForm.title"  />
                </el-form-item>
                <el-form-item label="公章图片" prop="logoarray">
                    <el-upload
                        :limit="1"
                        action="http://localhost:9999/cat/adopt/insertAdopt"
                        ref="uploadimg1"
                        list-type="picture-card"
                        :auto-upload="false"
                        :data="editForm"
                        :file-list="editForm.logoarray"
                        :on-remove="handleRemove1"
                        :on-change="handleChange1"
                        :http-request="uploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
               
                <el-form-item label="企业动态" prop="content">
                        <mavon-editor v-model="editForm.content" ref="md" @imgAdd="$imgAdd" @change="change" style="min-height: 600px"/>
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import {post} from '../../../api/request.js'
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
export default {
    name: 'basetable',
    components: {
        mavonEditor
    },
    data() {
        return {
            //富文本编辑器
                content:'',
                html:'',
                configs: {
            },
            
            companyid:'',
            //营业时间
           
            role:'',//登录角色
            maList:[],//管理员列表
            query: {
                company: '',
                pageIndex: 1,
                pageSize: 8
            },
            
             //添加数据
            addVisiable:false,
            addForm:{
                content:'',
                info_pic:[],
                title:''
            },
            url:'',
            //编辑数据
            editVisible:false,
            editForm:{},
            startTime: '',
            endTime: '',
            //添加数据表单验证
            rules: {
                content: [ { required: true, message: '请输入富文本', trigger: 'blur' }, ],
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            fileList:[],
            formdata:'',
            upvisiable:false
        };
    },
    
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    methods: {
        handleChange (file, fileList) {
            this.addForm.seal_pic = fileList;
        },
        handleRemove(file, fileList) {
            this.addForm.seal_pic = fileList;
        },
        handleChange1 (file, fileList) {
            this.editForm.logoarray = fileList;
        },
        handleRemove1(file, fileList) {
            this.addForm.logoarray = fileList;
        },
        handlePictureCardPreview(file) {
            this.adoptFormdialogImageUrl = file.url;
            this.adoptFormdialogVisible = true;
        },
        uploadFile(file){
            this.upvisiable = true
            this.formdata.append('img[]', file.file);
        },
         //重置搜索
        resetsearch(){
            this.query.content= '',
            this.getData()
        },
        // 将图片上传到服务器，返回地址替换到md中
        $imgAdd(pos, $file){
            var formdata = new FormData();
            formdata.append('file', $file);
            // 这里没有服务器供大家尝试，可将下面上传接口替换为你自己的服务器接口
            post('admin/file/url',formdata).then((res) => {
                this.$refs.md.$img2Url(pos, res.data);
            })
        },
        change(value, render){
            // render 为 markdown 解析后的结果
            this.html = render;
        },
        submit(){
            console.log(this.content);
            console.log(this.html);
            this.$message.success('提交成功！');
        },
        resetForm(formName) {
                this.$refs[formName].resetFields();
        },
        //添加数据
        addData(){
            this.$refs['addForm'].validate((valid) => {
            if (valid) {
                let config = {
                headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                this.formdata = new FormData()
                this.$refs.uploadimg.submit();
                this.formdata.append('content',this.addForm.content)
                this.formdata.append('title',this.addForm.title)
                this.formdata.append('label',this.html)
                this.formdata.append('company_id',this.companyid)
                post('admin/home/addinfo',this.formdata).then(res=>{
                     if(res.data.msg =="添加成功"){
                            this.$message.success("添加成功")
                            this.getData()
                            this.$refs['addForm'].resetFields();
                            this.addVisiable = false 
                            this.upvisiable = false
                        }
                        else{
                            this.$messaga.error("添加失败")
                        }          
                })
                }
            })
        },
        // 获取 easy-mock 的模拟数据
        getData() {
            let formdata = new FormData()
            formdata.append('content',this.query.content)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            formdata.append('company_id',this.companyid)
            let url ='admin/home/showinfo'
            post(url,formdata).then(res => {
                if(res.data.data.list){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                    }
                }
                else{
                    this.$messgea.error("暂无数据")
                }
            });
            
        },
        // 触发搜索按钮
        inputSearch() {
            let formdata = new FormData()
            formdata.append('content',this.query.content)
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            let url ='admin/company/companyinfo'
            if(sessionStorage.getItem('roleid') != 1){
                url='admin/company/companys'
                let id = sessionStorage.getItem('userid')
                formdata.append('id',id)
            }
            post(url,formdata).then(res => {
                if(res.data.data.list.length >=0){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                }
            });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                let formdata = new FormData()
                formdata.append('id',row.id)
                post('admin/home/deleinfo',formdata).then(res=>{
                    if(res.data.msg=="删除成功"){
                        this.$message.success('删除成功');
                        this.getData()
                    }
                    else
                        this.message.error('删除失败')
                })
            })
            .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].id + ',';
            }
            let formdata = new FormData()
            formdata.append('id',str)
            post('admin/home/alldele',formdata).then(res=>{
                if(res.data.msg == "删除成功"){
                    this.multipleSelection = [];
                    this.$message.success('删除成功')
                    this.getData()
                }
                else{
                    this.$message.error('删除失败')
                }
            })
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            let array = [{
                url:'',
                name:'1'
            }]
            array[0].url =this.editForm.img
            this.editForm.logoarray=array
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.formdata = new FormData()
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            this.$refs.uploadimg1.submit();
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    if(this.upvisiable){
                        this.upvisiable = false
                        this.formdata.append('id',this.editForm.id)
                        this.formdata.append('content',this.editForm.content)
                        this.formdata.append('label',this.html)
                        this.formdata.append('title',this.editForm.title)
                        post('admin/home/updates',this.formdata).then(res=>{
                            if(res.data.msg == "修改成功"){
                                this.getData()
                                this.$message.success('修改成功')
                                this.editVisible = false
                            }
                            else{
                                this.$message.error('修改失败')
                            }
                    })
                    }
                    else{
                        this.formdata.append('id',this.editForm.id)
                        this.formdata.append('content',this.editForm.content)
                        this.formdata.append('label',this.html)
                        this.formdata.append('title',this.editForm.title)
                        this.formdata.append('img',this.editForm.img)
                        post('admin/home/updates',this.formdata).then(res=>{
                            if(res.data.msg == "修改成功"){
                                this.getData()
                                this.$message.success('修改成功')
                                this.editVisible = false
                            }
                            else{
                                this.$message.error('修改失败')
                            }
                    })
                    }
                }
            })
        },
      
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
